import { render, staticRenderFns } from "./date-input.vue?vue&type=template&id=bd4157a2&scoped=true"
import script from "./date-input.ts?vue&type=script&lang=js&external"
export * from "./date-input.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd4157a2",
  null
  
)

export default component.exports